module.exports = __webpack_public_path__ + "img/point1.e5e86dd0.png";